import AppSyncNotification from "@/types/AppSyncNotification.interface";
import { store } from "@/store";
import router from "@/router/router";

const handlers = {
    xeroOAuthConnectComplete(notification: AppSyncNotification): void {
        store.getters.appDebug && console.log('XERO OAUTH CONNECT COMPLETE', notification)

        store.dispatch('tenantGet', store.getters.tenant.id)

        store.commit('xeroConnectionSet', { result: true })

        store.commit('xeroAccountSet', notification.xero_account)

        store.commit('dataProviderSyncProgressSet', { percent: 0, model: 'Xero Data' })

        store.dispatch('xeroSync')

        //  Hide the loading dialog
        store.commit('splashSet', null)

        //  If the 'goToXeroSettings' flag is set, navigate to xero setting
        if (notification.goToXeroSettings) router.push('/xero')
    }
}

export default {
    onAppSyncNotificationReceived(notification: AppSyncNotification): void {
        //  Check we Xero should handle this event
        const handler = handlers[notification.event]

        //  If the handler exists, run it
        if (handler) handler(notification)
    }
}
